// extracted by mini-css-extract-plugin
export default {"barracksForm":"BarracksForm_barracksForm__M+rfD","close":"BarracksForm_close__qM1cv","label":"BarracksForm_label__5pReO"};